export enum ExternalLookupTypeDTO {
  None = 0,
  Address,
  CityStateCountry,
  Facility,
  License,
  Education,
  BoardCertification,
  DEALicense,
  FacilityAddress,
}
